import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const COMMON_TIMEZONES = [
  {
    value: 'UTC',
    label: 'UTC',
    offset: 'UTC+0',
    locale: 'en-GB',
  },
  {
    value: 'Europe/Bucharest',
    label: 'Bucharest (EET/EEST)',
    offset: 'UTC+2/+3',
    locale: 'ro-RO',
  },
];

export const TIMEZONE_TO_LOCALE: Record<string, string> = {
  UTC: 'en-GB',
  'Europe/Bucharest': 'ro-RO',
  'Europe/Kiev': 'uk-UA',
};

interface TimezoneState {
  timezone: string;
  locale: string;
  setTimezone: (timezone: string) => void;
  setLocale: (locale: string) => void;
  getLocaleForTimezone: (timezone: string) => string;
}

export const useTimezoneStore = create<TimezoneState>()(
  persist(
    (set) => {
      const getLocaleForTimezone = (timezone: string) => {
        return TIMEZONE_TO_LOCALE[timezone] || navigator.language || 'en-US';
      };

      const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const defaultLocale = getLocaleForTimezone(defaultTimezone);

      return {
        timezone: defaultTimezone,
        locale: defaultLocale,
        setTimezone: (timezone: string) => {
          const locale = getLocaleForTimezone(timezone);
          set({ timezone, locale });
        },
        setLocale: (locale: string) => set({ locale }),
        getLocaleForTimezone,
      };
    },
    {
      name: 'timezone-storage',
    }
  )
);
